/**
 * DOM Element IDs and Selectors
 *
 * Centralized constants for DOM element IDs and selectors.
 * This prevents magic strings throughout the codebase and makes refactoring easier.
 */

/**
 * Element IDs
 */
export const ELEMENT_IDS = {
  HIRE_FORM: 'hire-form',
  APP_ROOT: 'root'
};

/**
 * CSS Selectors
 */
export const SELECTORS = {
  FOOTER: '.footer',
  HEADER: '.header',
  MAIN_CONTENT: '.main-content'
};

/**
 * Data Attributes
 */
export const DATA_ATTRIBUTES = {
  THEME: 'data-theme'
};
